import useSessionId from '@/core/auth/components/session-provider';
import authService from '@/core/auth/services/auth-service';

export interface SessionIdentity {
  sessionId: string | null;
  subject: ReturnType<typeof authService.getSubjectData>;
  userId: string;
}

export default function useSessionIdentity(): SessionIdentity {
  const sessionId = useSessionId();
  const subject = authService.getSubjectData();
  // subject.id is the same underlying value as credentials.body.sub — reuse
  // it instead of a second authService.getCredentials() call.
  const userId = subject?.id || '';

  return { sessionId, subject, userId };
}
